import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { TRButton } from "@/components/TRButton";
import { useAuth } from "@/context/AuthContext";
import { Field } from "./Login";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters.");
            return;
        }
        setLoading(true);
        try {
            await register(email, password, name);
            toast.success("Account created.");
            navigate("/account");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Registration failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="register-page" className="pt-32 md:pt-44 min-h-[80vh]">
            <div className="max-w-[440px] mx-auto px-5 sm:px-8">
                <span className="eyebrow text-ink/50">Account</span>
                <h1 className="mt-4 font-serif font-light text-5xl tracking-[-0.04em]">
                    Create account
                </h1>
                <form onSubmit={submit} className="mt-12 space-y-6">
                    <Field label="Name" type="text" value={name} onChange={setName} testid="register-name" />
                    <Field label="Email" type="email" value={email} onChange={setEmail} testid="register-email" />
                    <Field label="Password" type="password" value={password} onChange={setPassword} testid="register-password" />
                    <TRButton full type="submit" disabled={loading} data-testid="register-submit">
                        {loading ? "Creating…" : "Create Account"}
                    </TRButton>
                </form>
                <p className="mt-8 text-sm text-ink/60">
                    Already have an account?{" "}
                    <Link to="/login" className="text-ink link-underline" data-testid="to-login">
                        Sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
